<div class="container-scroller">

    <div class="main-panel">
        <div class="content-wrapper">
          


            <nz-card nzTitle="Pending Requests for Approval">
                <p style="font-size:14px;color:rgba(0, 0, 0, 0.85);margin-bottom:16px;font-weight: 500;"></p>
                <nz-card nzType="inner" nzTitle="Employee Count Change Requests"  >
                    <div class="row">

                        <div class="grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
        
        
                                    <ul nz-list [nzDataSource]="Requests" nzBordered nzSize="small" [nzNoResult]="noResult">
                                        <nz-list-header>
                                            Pending Requests
                                        </nz-list-header>
                                        <li nz-list-item *ngFor="let item of Requests">
        
                                            <p-card styleClass="p-card-shadow">
                                                <nz-list-item-meta-title>
                                                    Requester : {{ item.requesterMail }}
                                                </nz-list-item-meta-title>
        
                                                <nz-list-item-meta-title>
                                                    Date : {{ item.dateRequested | date: 'dd MMMM yyyy' }}
                                                </nz-list-item-meta-title>
                                                <nz-list-item-meta-title>
                                                    Approved No.: {{ item.currentNumber }}
                                                </nz-list-item-meta-title>
                                                <nz-list-item-meta-title>
                                                    Active No.: {{ item.activeNumberOfEmployees }}
                                                </nz-list-item-meta-title>
                                                <nz-list-item-meta-title>
                                                    Requested No.: {{ item.requestedNumber }}
                                                </nz-list-item-meta-title>
                                                <p>
                                                    Comment:   {{item.requesterComment}}
                                                </p>
        
                                                <ng-template pTemplate="footer">
                                            <nz-space [nzSize]="spacesize">
                                                    <p-button label="Approve" icon="pi pi-check"
                                                    nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                    (nzOnConfirm)="openApprovalModal(item.id)" (nzOnCancel)="cancel()"
                                                    
                                                    
                                                    ></p-button>
                                                  
                                                  
                                                    <p-button label="Reject" icon="pi pi-times" styleClass="p-button-secondary"
                                                        [style]="{'margin-left': '.5em'}"
                                                        
                                                        nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                        (nzOnConfirm)="openRejectionModal(item.id)" (nzOnCancel)="cancel()"
                                                        
                                                        
                                                        
                                                        ></p-button>
                                                    </nz-space>
                                                </ng-template>
                                            </p-card>
        
                                        </li>
                                      
                                    </ul>
        
        
        
                                  
                                </div>
                            </div>
                        </div>
        
        
        
                    </div>
                </nz-card>
                <nz-card nzType="inner" style="margin-top:16px;" nzTitle="Contract Renewal Requests" >
                    <div class="grid-margin stretch-card">
                        <div class="card">
                            <div class="card-body">
    
    
                                <ul nz-list [nzDataSource]="RenewalRequests" nzBordered nzSize="small" [nzNoResult]="noResult">
                                    <nz-list-header>
                                        <h6  >Pending Renewal Requests</h6>
                                    </nz-list-header>
                                    <li nz-list-item *ngFor="let item of RenewalRequests">
    
                                        <p-card styleClass="p-card-shadow">
                                            <nz-list-item-meta-title>
                                                Requester : {{ item.requesterMail }}
                                            </nz-list-item-meta-title>
    
                                            <nz-list-item-meta-title>
                                                Date : {{ item.dateRequested | date: 'dd MMMM yyyy' }}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Start Date : {{ item.currentActualStartDate | date: 'dd MMMM yyyy'}}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Active No.: {{ item.currentActiveNumberOfEmployees }}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Requested Start Date: {{ item.requestedStartDate | date: 'dd MMMM yyyy'}}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Requested Duration(Months): {{ item.requestedDuration }}                                             </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                End Date: {{ item.requestedEndDate | date: 'dd MMMM yyyy'}}
                                            </nz-list-item-meta-title>



                                            <p>
                                                Comment:   {{item.requesterComment}}
                                            </p>
    
                                            <ng-template pTemplate="footer">
                                        <nz-space [nzSize]="spacesize">
                                                <p-button label="Approve" icon="pi pi-check"
                                                nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                (nzOnConfirm)="openRenewalApprovalModal(item.id)" (nzOnCancel)="cancel()"
                                                
                                                
                                                ></p-button>
                                              
                                              
                                                <p-button label="Reject" icon="pi pi-times" styleClass="p-button-secondary"
                                                    [style]="{'margin-left': '.5em'}"
                                                    
                                                    nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                    (nzOnConfirm)="openRenewalRejectionModal(item.id)" (nzOnCancel)="cancel()"
                                                    
                                                    
                                                    
                                                    ></p-button>
                                                </nz-space>
                                            </ng-template>
                                        </p-card>
    
                                    </li>
                                  
                                </ul>
    
    
    
                              
                            </div>
                        </div>
                    </div>
                </nz-card>

                <nz-card nzType="inner" style="margin-top:16px;" nzTitle="Emloyee Exit Requests" >
                    <div class="grid-margin stretch-card">
                        <div class="card">
                            <div class="card-body">
    
    
                                <ul nz-list [nzDataSource]="ExitRequests" nzBordered nzSize="small" [nzNoResult]="noResult">
                                    <nz-list-header>
                                        <h6  >Pending Exit Requests</h6>
                                    </nz-list-header>
                                    <li nz-list-item *ngFor="let item of ExitRequests">
    
                                        <p-card styleClass="p-card-shadow">
                                            <nz-list-item-meta-title>
                                                Requester : {{ item.requester }}
                                            </nz-list-item-meta-title>
    
                                            <nz-list-item-meta-title>
                                                Date : {{ item.requestDate | date: 'dd MMMM yyyy' }}
                                            </nz-list-item-meta-title>
											  <nz-list-item-meta-title>
                                                Employee Name : {{ item.empName}}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Start Date : {{ item.currentStartDate | date: 'dd MMMM yyyy'}}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                End Date: {{ item.currentExitDate | date: 'dd MMMM yyyy' }}
                                            </nz-list-item-meta-title>
                                            <nz-list-item-meta-title>
                                                Requested Exit Date: {{ item.requestExitDate | date: 'dd MMMM yyyy'}}
                                            </nz-list-item-meta-title>
                                         



                                            <p>
                                                Comment:   {{item.requesterComment}}
                                            </p>
    
                                            <ng-template pTemplate="footer">
                                        <nz-space [nzSize]="spacesize">
                                                <p-button label="Approve" icon="pi pi-check"
                                                nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                (nzOnConfirm)="openExitApprovalModal(item.id)" (nzOnCancel)="cancel()"
                                                
                                                
                                                ></p-button>
                                              
                                              
                                                <p-button label="Reject" icon="pi pi-times" styleClass="p-button-secondary"
                                                    [style]="{'margin-left': '.5em'}"
                                                    
                                                    nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                    (nzOnConfirm)="openRenewalRejectionModal(item.id)" (nzOnCancel)="cancel()"
                                                    
                                                    
                                                    
                                                    ></p-button>
                                                </nz-space>
                                            </ng-template>
                                        </p-card>
    
                                    </li>
                                  
                                </ul>
    
    
    
                              
                            </div>
                        </div>
                    </div>
                </nz-card>
              </nz-card>
             
        </div>
    
    </div>

</div>

<!--  Approval  Modal  -->
<nz-modal [(nzVisible)]="isApprovalModalVisible" nzTitle="Approve Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="ApprovalMessage" rows="4" name="ApprovalMessage"
          [(ngModel)]="ApprovalMessage" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendApproval()" [disabled]="isChangeOkLoading">Submit</button>
    </div>
  
  </nz-modal>

  <!--  Rejection  Modal  -->
<nz-modal [(nzVisible)]="isRejectionModalVisible" nzTitle="Reject Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="RejectionMessage" rows="4" name="RejectionMessage"
          [(ngModel)]="RejectionMessage" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendRejection()" [disabled]="isChangeLoading">Submit</button>
    </div>
  
  </nz-modal>

  <!--

  -->
  <!--  Renewal Approval  Modal  -->
<nz-modal [(nzVisible)]="isRenewalApprovalModalVisible" nzTitle="Approve Renewal Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="RenewalApprovalComment" rows="4" name="RenewalApprovalComment"
          [(ngModel)]="RenewalApprovalComment" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendRenewalApproval()" [disabled]="isChangeOkLoading">Submit</button>
    </div>
  
  </nz-modal>


  <!--  Rejection Renewal Modal  -->
<nz-modal [(nzVisible)]="isRenewalRejectionModalVisible" nzTitle="Reject Renewal Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="RenewalRejectionMessage" rows="4" name="RenewalRejectionMessage"
          [(ngModel)]="RenewalRejectionMessage" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendRenewalRejection()" [disabled]="isChangeLoading">Submit</button>
    </div>
  
  </nz-modal>



    <!--  Exit Approval  Modal  -->
<nz-modal [(nzVisible)]="isExitApprovalModalVisible" nzTitle="Approve Exit Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="ExitApprovalComment" rows="4" name="ExitApprovalComment"
          [(ngModel)]="ExitApprovalComment" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendExitApproval()" [disabled]="isChangeOkLoading">Submit</button>
    </div>
  
  </nz-modal>

    <!--  ExitRequest Rejection Modal  -->
<nz-modal [(nzVisible)]="isExitRejectionModalVisible" nzTitle="Reject Exit Request" (nzOnCancel)="handleCancel()">

    <div *nzModalContent>
      <div class="form-group">
        <label for="justification">Comment</label>
        <textarea class="form-control" id="ExitRejectionMessage" rows="4" name="ExitRejectionMessage"
          [(ngModel)]="ExitRejectionMessage" required></textarea>
      </div>
    </div>
  
    <div *nzModalFooter>
      <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="sendExitRejection()" [disabled]="isChangeLoading">Submit</button>
    </div>
  
  </nz-modal>
